import React, {useEffect} from "react";
import {createPortal} from "react-dom";
import {formatSimmsDateTimeKorean} from "../../../../../../components/commonmethod/CommonMethod";
import "./assetMemoModal.css";

function AssetMemoDetailModal({open, item, onClose}) {
    useEffect(() => {
        if (!open) return;

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        const onKeyDown = (e) => {
            if (e.key === "Escape") {
                onClose?.();
            }
        };
        window.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener("keydown", onKeyDown);
        };
    }, [open, onClose]);

    if (!open || !item || typeof document === "undefined") {
        return null;
    }

    return createPortal(
        <div className="asset-memo-modal-root">
            <div className="asset-memo-modal-overlay" onClick={onClose} aria-hidden />
            <div
                className="asset-memo-modal"
                role="dialog"
                aria-modal="true"
                aria-labelledby="asset-memo-detail-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="asset-memo-modal__header">
                    <div>
                        <h3 id="asset-memo-detail-modal-title" className="asset-memo-modal__title">
                            자산기록 상세
                        </h3>
                        <p className="asset-memo-modal__meta">{item.title || "제목 없음"}</p>
                    </div>
                    <button
                        type="button"
                        className="asset-memo-modal__close"
                        onClick={onClose}
                        aria-label="닫기"
                    >
                        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                            <path
                                d="M18 6L6 18M6 6l12 12"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </button>
                </div>

                <div className="asset-memo-modal__body">
                    <div className="asset-memo-modal__field">
                        <span className="asset-memo-modal__label">등록일시</span>
                        <div className="asset-memo-modal__value">
                            {formatSimmsDateTimeKorean(item.createdAt) || "\u00A0"}
                        </div>
                    </div>

                    <div className="asset-memo-modal__field">
                        <span className="asset-memo-modal__label">기록관리 코드</span>
                        <div className="asset-memo-modal__value">
                            {item.code?.name || "\u00A0"}
                        </div>
                    </div>

                    <div className="asset-memo-modal__field">
                        <span className="asset-memo-modal__label">제목</span>
                        <div className="asset-memo-modal__value">{item.title || "\u00A0"}</div>
                    </div>

                    <div className="asset-memo-modal__field">
                        <span className="asset-memo-modal__label">내용</span>
                        <div className="asset-memo-modal__value asset-memo-modal__value--multiline">
                            {item.content || "\u00A0"}
                        </div>
                    </div>

                    <div className="asset-memo-modal__field">
                        <span className="asset-memo-modal__label">등록자</span>
                        <div className="asset-memo-modal__value">
                            {item.createdBy?.name || "\u00A0"}
                        </div>
                    </div>
                </div>

                <div className="asset-memo-modal__footer">
                    <button
                        type="button"
                        className="asset-memo-modal__btn is-primary"
                        onClick={onClose}
                    >
                        닫기
                    </button>
                </div>
            </div>
        </div>,
        document.body,
    );
}

export default AssetMemoDetailModal;
